/**
 * HPQ Scroll Reveal — IntersectionObserver fade-up on section entry.
 * Adds .hpq-reveal--visible when sections enter viewport.
 * Respects prefers-reduced-motion.
 */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('hpq-reveal--visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.main > .shopify-section').forEach(function (section) {
    section.classList.add('hpq-reveal');
    observer.observe(section);
  });
})();
